import { GoogleOAuthProvider } from '@react-oauth/google';
import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AboutUs from './Aboutus';
import './App.css';
import Contact from './Contact';
import { AuthProvider } from './context/AuthProvider';
import Disclaimer from './Disclaimer';
import Company from './Company'
import Investor from './Investor'
import Faq from './Faq';
import Feedback from './Feedback';
import Footer from './Footer';
import HeaderWrapper from './HeaderWrapper';
import Home from './Home';
import useAuth from './hooks/useAuth';
import useAxiosPrivate from "./hooks/useAxiosPrivate";
import PageNotFound from './PageNotFound';
import Profile from './Profile';
import Terms from './Terms';
import Holdings from './Holdings'
import CompanyInvestorMain from './CompanyInvestorMain'
import DataFeed from './DataFeed'

import { BrowserView, MobileView } from 'react-device-detect';
import MobileHeader from './Mobile/MobileHeader'
import FooterMobile from './Mobile/FooterMobile'
import FaqMobile from './Mobile/FaqMobile'
import FeedbackMobile from './Mobile/FeedbackMobile'
import AboutUsMobile from './Mobile/AboutUsMobile'
import TermsMobile from './Mobile/TermsMobile'
import DisclaimerMobile from './Mobile/DisclaimerMobile'
import HomeMobile from './Mobile/HomeMobile'
import InvestorMobile from './Mobile/InvestorMobile'
import CompanyMobile from './Mobile/CompanyMobile'
import HoldingMobile from './Mobile/HoldingMobile'
import CompanyInvestorMainMobile from './Mobile/CompanyInvestorMainMobile'
import DataFeedMobile from './Mobile/DataFeedMobile'
import ProfileMobile from './Mobile/ProfileMobile'

function debounce(fn, ms) {
    let timer
    return _ => {
        clearTimeout(timer)
        timer = setTimeout(_ => {
            timer = null
            fn.apply(this, arguments)
        }, ms)
    };
}



function App() {
    const [pageData, setPageData] = useState({});
    const [dimensions, setDimensions] = React.useState({
        height: window.innerHeight,
        width: window.innerWidth
    })
    const { auth } = useAuth();
    const axiosPrivate = useAxiosPrivate();
    const getData = async () => {
        if (auth?.user) {
            const response = await axiosPrivate.get("https://gurus.niveshkarma.com/api/v1/super-investors")
            //const response = await axios.get("./details.json")
            setPageData(response.data)
        }
    }
    useEffect(() => {
        const debouncedHandleResize = debounce(function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth
            })
        }, 1000)

        window.addEventListener('resize', debouncedHandleResize)

        return _ => {
            window.removeEventListener('resize', debouncedHandleResize)

        }
    }, []);
    return (
        <AuthProvider>
            <div className="App">
                <BrowserView>
                <div className="Home" style={{ backgroundColor: "rgb(248, 248, 252)", fontSize: "14px" }}>
                    <HeaderWrapper/>
                    
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/DataFeed" element={<DataFeed />} />
                            <Route path="/Company/:companyName" element={<Company />} />
                            <Route path="/Investor/:investor" element={<Investor />} />
                            <Route path="/OurStory" element={<AboutUs />} />
                            <Route path="/FAQ" element={<Faq />} />
                            <Route path="/Terms" element={<Terms />} />
                            <Route path="/Disclaimer" element={<Disclaimer />} />
                            <Route path="/Feedback" element={<Feedback />} />
                            <Route path="/Profile" element={<Profile />} />
                            <Route path="/Contact" element={<Contact />} />
                            <Route path="/Holdings" element={<Holdings />} />
                            <Route path="/CompanyInvestor/:companyName" element={<CompanyInvestorMain />} />
                            <Route path="*" element={<PageNotFound />} />
                        </Routes>
                    

                        </div>
                    <Footer />
                </BrowserView>
                <MobileView>
                    <MobileHeader />
                    <div style={{ padding: "50px 0px", backgroundColor:"rgb(248, 248, 252)"}}>
                    <Routes>
                        <Route path="/" element={<HomeMobile />} />
                        <Route path="/DataFeed" element={<DataFeedMobile />} />
                        <Route path="/Investor/:investor" element={<InvestorMobile />} />
                        <Route path="/OurStory" element={<AboutUsMobile />} />
                        <Route path="/FAQ" element={<FaqMobile />} />
                        <Route path="/Feedback" element={<FeedbackMobile />} />
                        <Route path="/Terms" element={<TermsMobile />} />
                        <Route path="/Disclaimer" element={<DisclaimerMobile />} />
                        <Route path="/Company/:companyName" element={<CompanyMobile />} />
                        <Route path="/CompanyInvestor/:companyName" element={<CompanyInvestorMainMobile />} />
                            <Route path="/Holdings" element={<HoldingMobile />} />
                            <Route path="/Profile" element={<ProfileMobile />} />
                        </Routes>
                    </div>
                    <FooterMobile />
                </MobileView>
            </div>
        </AuthProvider>
  );
}
const AppName = () => (
    <BrowserRouter>
        <GoogleOAuthProvider clientId="293375405749-i8qhl8aujplmiapclijjv0ffqob8enr4.apps.googleusercontent.com">
            <App />
        </GoogleOAuthProvider>
    </BrowserRouter>
)

export default AppName;
